var React = require('react');

function IcArrowComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-arrow up"},React.createElement("path",{"id":"icons/ic-arrow-language","d":"M14.3356 14.7474C14.7484 15.1143 15.3805 15.0771 15.7474 14.6644C16.1143 14.2516 16.0771 13.6195 15.6644 13.2526L12.1644 9.25258C11.7855 8.91579 11.2145 8.91579 10.8356 9.25258L7.33563 13.2526C6.92284 13.6195 6.88566 14.2516 7.25258 14.6644C7.6195 15.0771 8.25157 15.1143 8.66435 14.7474L11.5 11.3379L14.3356 14.7474Z","fill":"#3E3E3E"})));
}

IcArrowComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcArrowComponent;

IcArrowComponent.default = IcArrowComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownV2/images/ic-arrow.component.svg
// module id = 1621
// module chunks = 0